//多语言
export default function kygMsg(msgid, msg0) {
    var f = window.kygMsg
    return f ? f(msgid, msg0) : msg0
}
